import React, { useState, useEffect } from "react";
import CgFormCreator from "../../../common/CgFormCreator";
import AddedValuesList from "../../../common/AddedValuesList";
import PopupModal from "../../../common/PopupModal";
import "./specialityboard.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSPBDCertificationList,
  deleteProviderSPBDCert,
  fetchSpecialtyBoardOptions,
  fetchSpecialtyCertifications,
  addProviderSPBDCertifications,
} from "../../../store/ProviderInfo/ProviderSpecialityActions";
import { addProviderSPBDCert } from "../../../store/ProviderInfo/ProviderSpecialityReducer";
import { useLocation } from "react-router-dom";
import "./specialityboard.scss";

const SpecialityBoard = () => {
  const location = useLocation();
  const locationData = location.pathname.split("/");
  const providerId = locationData[2];
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const [renderErrorMsg, setRenderErrorMsg] = useState("");
  const [emptyQuery, setEmptyQuery] = useState(false);
  const [spboardValues, setAddedSpBoardValues] = useState();
  const [selectedBoardType, setSelectedBoardType] = useState("");
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [specialtyBoardSuggestions, setSpecialtyBoardSuggestions] = useState(
    []
  );
  const [spBoardCertificationDropdown, setSpBoardCertificationDropdown] =
    useState([]);
  // const [enableBoardTypeField, setEnableBoardTypeField] = useState(false);
  const [enableSpecialtyBoardField, setEnableSpecialtyBoardField] = useState(false);
  const [enableCertificationField, setEnableCertificationField] = useState(false);
  const [enableAddButton, setEnableAddButton] = useState(false);

  const dispatch = useDispatch();
  const { isSPBDLoading, spbdData } = useSelector(
    (state) => state.providerSPBDCertificate
  );

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setAddedSpBoardValues(spbdData);
  }, [spbdData]);

  useEffect(() => {
    if (errorMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    }
  }, [errorMsg]);

  useEffect(() => {
    dispatch(fetchSPBDCertificationList(providerId));
  }, []);

  const handleBoardTypeChange = (value) => {
    setSelectedBoardType(value);
    setSelectedBoard(null);
    setSpecialtyBoardSuggestions([]);
    setSpBoardCertificationDropdown([{ id: 0, value: "Select Certification" }]);
  };

  const handleSpecialtyBoardSearch = (query) => {
    if (query && query.trim() !== "" && selectedBoardType) {
      dispatch(
        fetchSpecialtyBoardOptions({
          query: query.trim(),
          type: selectedBoardType,
        })
      ).then((response) => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.specialtyBoardRawSearchResponseDTO
        ) {
          const boardData =
            response.payload.data.specialtyBoardRawSearchResponseDTO;
          setSpecialtyBoardSuggestions([
            {
              name: boardData.name,
              id: Date.now().toString(),
            },
          ]);

          if (boardData.name) {
            fetchCertificationsForBoard(boardData.name);
          }
        }
      });
    } else {
      setSpecialtyBoardSuggestions([]);
    }
  };

  const fetchCertificationsForBoard = (boardName) => {
    if (boardName) {
      dispatch(fetchSpecialtyCertifications(boardName)).then((response) => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.specialtyCertRawSearchResponseDTO
        ) {
          const certData =
            response.payload.data.specialtyCertRawSearchResponseDTO;

          const formattedCertifications = certData.map((cert, index) => ({
            id: index + 1,
            value: cert.name,
          }));

          const certDropdown = [
            { id: 0, value: "Select Certification" },
            ...formattedCertifications,
          ];

          setSpBoardCertificationDropdown(certDropdown);
          setEnableCertificationField(true);
        }
      });
    }
  };

  const handleSpecialtyBoardSelect = (selectedBoardValue) => {
    setSelectedBoard(selectedBoardValue);
    if (selectedBoardValue && selectedBoardValue.name) {
      fetchCertificationsForBoard(selectedBoardValue.name);
    }
  };

  const specialityBoardDropdown = [
    { id: 0, value: "Medical" },
    { id: 1, value: "Dental" },
  ];

  const AddSpecialityBoardSchema = [
    {
      component: "dropdown",
      label: "BOARD TYPE",
      name: "boardtype",
      dropdownPlaceHolder: "Select board type",
      defaultValue: "",
      dropdownOptions: specialityBoardDropdown,
      onSelectCallBack: (res, data) => {
        handleBoardTypeChange(data);
        if (data && data !== "") {
          setEnableSpecialtyBoardField(true);
        } else {
          setEnableSpecialtyBoardField(false);
          setEnableCertificationField(false);
          setEnableAddButton(false);
        }
      },
      required: false,
    },
    {
      component: "autoComplete",
      emptySearchField: emptyQuery,
      id: "name",
      label: "SPECIALTY BOARD",
      type: "text",
      name: "name",
      autoCompletePlaceHolders:
        "Type to search by specialty board name",
      required: false,
      defaultValue: selectedBoard ? selectedBoard.name : "",
      suggestions: specialtyBoardSuggestions,
      deleteItem: () => {},
      renderAddedValues: false,
      isMultiple: false,
      disabled: !enableSpecialtyBoardField,
      onValueChangeCallback: (query) => {
        handleSpecialtyBoardSearch(query);
        if (query && specialtyBoardSuggestions.length > 0) {
          const matchedSuggestion = specialtyBoardSuggestions.find(
            suggestion => suggestion.name.toLowerCase() === query.toLowerCase()
          );
          if (matchedSuggestion) {
            handleSpecialtyBoardSelect(matchedSuggestion);
            setEnableCertificationField(true);
          }
        } else if (!query || query.trim() === "") {
          setSelectedBoard(null);
          setEnableCertificationField(false);
          setEnableAddButton(false);
        }
      },
      onValueSave: () => {},
      errorCallback: () => {
        setErrorMsg("This certification already exists");
        setTimeout(() => {
          setErrorMsg("");
        }, 5000);
      },
      noErrorInAutoComplate: true,
    },
    {
      component: "dropdown",
      label: "CERTIFICATION",
      dropdownPlaceHolder: "Select Certification",
      name: "certification",
      defaultValue: "",
      dropdownOptions: spBoardCertificationDropdown,
      onSelectCallBack: (res, data) => {
        if (data && data !== "" && data !== "Select Certification") {
          setEnableAddButton(true);
        } else {
          setEnableAddButton(false);
        }
      },
      required: false,
      disabled: !enableCertificationField,
    },
  ];

  const toggleConfirmDelete = (specialtyCertDisplayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [specialtyCertDisplayId]: value,
    }));
  };

  const deleteAPiCall = async (specialtyCertDisplayId) => {
    try {
      await dispatch(
        deleteProviderSPBDCert({
          providerId: providerId,
          specialtyCertDisplayId: specialtyCertDisplayId,
        })
      );

      setConfirmDeleteMap((prev) => ({
        ...prev,
        [specialtyCertDisplayId]: false,
      }));

      await dispatch(fetchSPBDCertificationList(providerId));
    } catch (error) {
      setErrorMsg(error);
    }
  };

  const renderFormCreatorForSPBoardCert = () => {
    if (isSPBDLoading) return null;
    return (
      <div>
        <CgFormCreator
          primaryButton="+ADD"
          noCancel
          enablePrimaryBtn={enableAddButton}
          onSubmitCallback={(val) => {
            if (errorMsg !== "") {
              setEmptyQuery(true);
              setTimeout(() => {
                setEmptyQuery(false);
              }, 2000);
              setRenderErrorMsg(errorMsg);
            } else {
              setRenderErrorMsg("");

              const addedValue = {
                boardName: val.name,
                certificationName: val.certification,
                boardType: val.boardtype,
                displayId: Date.now().toString(20),
                isValid: true,
              };

              const newValue = spboardValues ? [...spboardValues] : [];
              newValue.push(addedValue);
              setAddedSpBoardValues(newValue);

              setSelectedBoard(null);
              setSpBoardCertificationDropdown([
                { id: 0, value: "Select Certification" },
              ]);
              setSelectedBoardType("");
              setEnableSpecialtyBoardField(false);
              setEnableCertificationField(false);
              setEnableAddButton(false);
            }
          }}
          schema={AddSpecialityBoardSchema}
          onCancel={() => {
            setOpenPopup(false);
          }}
          showErrorMsg={renderErrorMsg}
        />
        <AddedValuesList
          key={spboardValues}
          onSave={async (res) => {
            try {
              const currentCerts = spbdData || [];
              const resultIds = res.map((item) => item.id);
              const removedCerts = currentCerts.filter(
                (cert) =>
                  !resultIds.includes(cert.specialtyCertDisplayId) &&
                  cert.isValid === true
              );

              for (const cert of removedCerts) {
                await dispatch(
                  deleteProviderSPBDCert({
                    providerId: providerId,
                    specialtyCertDisplayId: cert.specialtyCertDisplayId,
                  })
                );
              }

              const result = res?.map((item) => {
                return item.metadata;
              });

              const certifications = result
                .filter((item) => item.isValid === true)
                .map((item) => ({
                  boardName: item.boardName || item.name,
                  certificationName:
                    item.certificationName || item.certification,
                }));

              if (certifications.length > 0) {
                await dispatch(
                  addProviderSPBDCertifications({
                    providerId: providerId,
                    certifications: certifications,
                  })
                );
              }

              dispatch(addProviderSPBDCert(result));

              await dispatch(fetchSPBDCertificationList(providerId));

              setOpenPopup(!openPopup);
            } catch (error) {
              setErrorMsg(error);
            }
          }}
          enableSave
          addedValuesHeading="Your Specialty Board Certifications"
          primaryButton="SAVE"
          secondaryButton="CANCEL"
          addedValuesList={spboardValues
            ?.filter((item) => item.isValid === true)
            .map((item) => {
              return {
                name: `${item.boardName || item.name} - ${
                  item.certificationName || item.certification
                }`,
                id: item.specialtyCertDisplayId || item.displayId,
                metadata: item,
              };
            })}
          onClose={() => {
            setOpenPopup(false);
            setErrorMsg("");
            setRenderErrorMsg("");
            setAddedSpBoardValues(spbdData);
            setSelectedBoard(null);
            setSpBoardCertificationDropdown([
              { id: 0, value: "Select Certification" },
            ]);
          }}
        />
      </div>
    );
  };

  const renderSPBoardCertPopupModal = () => {
    return (
      <div>
        <PopupModal
          customRender={renderFormCreatorForSPBoardCert}
          isOpen={openPopup}
          onSave={async () => {
            const certifications =
              spboardValues
                ?.filter((item) => item.isValid === true)
                .map((item) => ({
                  boardName: item.boardName || item.name,
                  certificationName:
                    item.certificationName || item.certification,
                })) || [];

            if (certifications.length > 0) {
              await dispatch(
                addProviderSPBDCertifications({
                  providerId: providerId,
                  certifications: certifications,
                })
              );

              await dispatch(fetchSPBDCertificationList(providerId));
            }

            setOpenPopup(!openPopup);
          }}
          onClose={() => {
            setOpenPopup(!openPopup);
            setAddedSpBoardValues(spbdData);
            setSelectedBoard(null);
            setSpBoardCertificationDropdown([
              { id: 0, value: "Select Certification" },
            ]);
          }}
          popupHeading={"Add Specialty Board Certifications"}
        />
      </div>
    );
  };

  const renderSPBoardCertification = () => {
    if (isSPBDLoading) return null;
    return (
      <div>
        {spbdData
          ?.filter((item) => item.isValid === true)
          .map((item, index) => {
            return (
              <div className="gencert-list" key={index}>
                {item.boardName} - {item.certificationName}
                <div className="deleteBtnwithConfirm">
                  {confirmDeleteMap[item.specialtyCertDisplayId] && (
                    <button
                      type="button"
                      className="btn border-0 canceldelete"
                      onClick={() =>
                        toggleConfirmDelete(item.specialtyCertDisplayId, false)
                      }
                    >
                      CANCEL
                    </button>
                  )}
                  <button
                    type="button"
                    className={`btn ${
                      confirmDeleteMap[item.specialtyCertDisplayId]
                        ? "deleteConfirmation"
                        : "border-0"
                    }`}
                    onClick={() => {
                      if (confirmDeleteMap[item.specialtyCertDisplayId]) {
                        deleteAPiCall(item.specialtyCertDisplayId);
                      } else {
                        toggleConfirmDelete(item.specialtyCertDisplayId, true);
                      }
                    }}
                  >
                    {confirmDeleteMap[item.specialtyCertDisplayId]
                      ? "CONFIRM"
                      : "DELETE"}
                  </button>
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className="speciality-board general-Certificate">
      <h3 className="section-header top-thirty overview">
        Specialty Board Certifications
        <a
          className="btn edit-button"
          onClick={() => {
            setOpenPopup(!openPopup);
            setSelectedBoardType("");
            setSelectedBoard(null);
            setSpecialtyBoardSuggestions([]);
            setSpBoardCertificationDropdown([]);
            setEnableSpecialtyBoardField(false);
            setEnableCertificationField(false);
            setEnableAddButton(false);
          }}
        >
          +Add
        </a>
      </h3>
      <div className="general-certification-body">
        {showError && (
          <div className="alert alert-danger" role="alert">
            {errorMsg}
          </div>
        )}
        {spbdData?.filter((item) => item.isValid === true).length > 0 ? (
          renderSPBoardCertification()
        ) : (
          <div className="info-section ng-isolate-scope">
            <p className="empty-module ng-binding">
              No specialty board certifications for this provider
            </p>
          </div>
        )}
        {renderSPBoardCertPopupModal()}
      </div>
    </div>
  );
};

export default SpecialityBoard;
